// Access-control preparation that legitimately needs store state.
//
// Split out of auth.helper.js so the shared auth helpers stay free of store imports.

const GUIDE_EDIT_RESTRICTION_FIELDS = [
    'group',
    'order',
    'schedule',
    'segment',
    'status',
    'conversion',
    'experiment',
];

const RC_EDIT_RESTRICTION_FIELDS = ['segment', 'status'];

const PERMITTED_APP_PLATFORMS = ['ios', 'android'];

export function alterApplicationAccessControl (accessControl) {
    let altered = accessControl;

    // With this feature flag on we must edit some guide and rc permissions for non-mobile applications:
    //     1) no guide creates are allowed and will be removed
    //     2) all guide edits must have a specific set of fields that can be edited
    //     3) only RC edits and publishes are allowed
    //     4) for rc you can only edit segment and status
    const { useSubscriptionStore } = require('@/stores/subscription.store');
    if (useSubscriptionStore().getFeatureFlag('enableGuideCopyEditRestrictions')) {
        const { useAppsStore } = require('@/stores/apps.store');
        const appsStore = useAppsStore();
        altered = Object.entries(accessControl).reduce((newAccessControl, [appId, perms]) => {
            const app = appsStore.getAppById(appId);

            if (!app) {
                return newAccessControl;
            }

            if (!PERMITTED_APP_PLATFORMS.includes(app.platform)) {
                const alteredPerms =
                    perms &&
                    perms.reduce((filteredPerms, perm) => {
                        switch (perm.entity) {
                            case 'guide':
                                if (perm.action === 'edit') {
                                    perm.fields = GUIDE_EDIT_RESTRICTION_FIELDS;
                                }

                                if (perm.action !== 'create') {
                                    filteredPerms.push(perm);
                                }
                                break;
                            case 'resourceCenter':
                                if (perm.action === 'edit') {
                                    perm.fields = RC_EDIT_RESTRICTION_FIELDS;
                                    filteredPerms.push(perm);
                                } else if (perm.action === 'publish') {
                                    filteredPerms.push(perm);
                                }
                                break;
                            default:
                                filteredPerms.push(perm);
                        }

                        return filteredPerms;
                    }, []);

                newAccessControl[appId] = alteredPerms;
            } else {
                newAccessControl[appId] = perms;
            }

            return newAccessControl;
        }, {});
    }

    return altered;
}

export function prepareAccessControlFromUser (user) {
    let {
        applicationAccessControl = {},
        subscriptionAccessControl = [],
        organizationAccessControl = {},
    } = user;

    applicationAccessControl = alterApplicationAccessControl(applicationAccessControl);

    return {
        applicationAccessControl,
        subscriptionAccessControl,
        organizationAccessControl,
    };
}
